export const ADDRESS_TYPE = {
  HOME: "home",
  BUSINESS: "business",
};

export type AddressType = (typeof ADDRESS_TYPE)[keyof typeof ADDRESS_TYPE];

export interface Address {
  id: number | null;
  address_type: AddressType | null;
  street_address: string | null;
  state: string | null;
  city: string | null;
  zip: string | null;
  country: string | null;
  start_date?: string | null;
}
